import palette from "assets/theme/base/palette";

function item(theme, ownerState) {
  const { borders, transitions } = theme;
  const { active } = ownerState;
  const { borderRadius } = borders;

  return {
    pl: 0,
    mt: 0.25,
    mb: 0.25,
    width: "calc(100% - 16px)",
    marginLeft: "8px",
    marginRight: "8px",
    borderRadius: borderRadius.md,
    cursor: "pointer",
    background: active === true ? palette.white : "transparent",
    boxShadow: active === true ? "0 4px 12px rgba(0,0,0,0.12)" : "none",
    transition: transitions.create(["background", "box-shadow"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    "&:hover": {
      background: active === true ? palette.white : "rgba(255,255,255,0.15)",
    },
  };
}

function itemContent(theme, ownerState) {
  const { typography, transitions, functions } = theme;
  const { miniSidenav, active } = ownerState;
  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem, rgba } = functions;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: `${pxToRem(10)} ${pxToRem(16)}`,
    marginLeft: pxToRem(18),
    userSelect: "none",
    position: "relative",

    "& span": {
      color: active === true ? palette.brand[700] : rgba(palette.white, 0.85),
      fontWeight: active === true ? fontWeightMedium : fontWeightRegular,
      fontSize: size.sm,
      opacity: miniSidenav ? 0 : 1,
      transition: transitions.create(["opacity", "color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
  };
}

function itemArrow(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, open, active } = ownerState;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    fontSize: `${size.lg} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: open ? "rotate(0)" : "rotate(-180deg)",
    color: active ? palette.brand[600] : rgba(palette.white, 0.5),
    transition: transitions.create(["color", "transform"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      display: miniSidenav ? "none !important" : "block !important",
    },
  };
}

export { item, itemContent, itemArrow };
